<template>
  <div class="ear-lobe-container">
    <div class="content-section">
      <h2 class="pb-2 border-bottom">
        Reparo de Lóbulo da Orelha & Otomodelação Não Cirúrgica
      </h2>
      <p>
        Na Diverse Care Now, oferecemos procedimentos simples e seguros para
        restaurar equilíbrio, corrigir assimetrias e reparar lóbulos das orelhas
        — sem a necessidade de cirurgia tradicional. Nosso objetivo é entregar
        resultados naturais com mínimo tempo de recuperação.
      </p>
      <h3>Quem pode se beneficiar da otomodelação?</h3>
      <ul>
        <li>
          Pacientes com lóbulos rasgados ou alongados (frequentemente por
          brincos).
        </li>
        <li>Indivíduos com orelhas proeminentes ou assimétricas.</li>
        <li>Irregularidades leves que não exigem cirurgia.</li>
        <li>Pessoas que buscam correções sutis, sem cicatrizes visíveis.</li>
      </ul>
      <h3>Técnicas utilizadas</h3>
      <ul>
        <li>
          Preenchimento dérmico — restaura forma e volume para um contorno mais
          equilibrado.
        </li>
        <li>
          Fios PDO / PLLA — lifting minimamente invasivo para corrigir ângulos e
          melhorar simetria.
        </li>
        <li>
          PRP ou preenchimento para rejuvenescimento — devolve elasticidade e
          previne novas lesões.
        </li>
        <li>
          Remoção de cistos — procedimento rápido e seguro, com anestesia local.
        </li>
      </ul>
      <h3>Visão geral do procedimento</h3>
      <ul>
        <li>Anestesia local para conforto.</li>
        <li>Aplicação de preenchedores, fios ou PRP conforme necessário.</li>
        <li>Resultados imediatos, com inchaço mínimo (24–48h).</li>
      </ul>
      <p>
        "Dos cuidados estéticos ao tratamento de cistos, nossos procedimentos
        minimamente invasivos devolvem conforto, equilíbrio e confiança."
      </p>
    </div>
    <div class="otomodeling-video">
      <iframe
        width="320"
        height="568"
        style="
          max-width: 100%;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        "
        src="https://www.youtube.com/embed/9rbA47bOvms"
        title="YouTube Shorts: Ear Lobe Repair"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "EarLobeRepairContentPtBR",
};
</script>

<style scoped>
.ear-lobe-container {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.content-section {
  flex: 1;
  min-width: 0;
}

.otomodeling-video {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
}

.otomodeling-video iframe {
  width: 320px;
  height: 568px;
  max-width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

/* Responsive design */
@media (max-width: 768px) {
  .ear-lobe-container {
    flex-direction: column;
    gap: 1.5rem;
  }

  .otomodeling-video {
    align-self: center;
  }

  .otomodeling-video iframe {
    width: 280px;
    height: 497px;
  }
}

@media (max-width: 480px) {
  .otomodeling-video iframe {
    width: 240px;
    height: 426px;
  }
}
</style>
